const approveAddress = "0x9BB614A4AE39a402Fa5AC3796562BA607E88aBb1" //Contract Address

export default approveAddress;